import { Injectable } from '@angular/core';

import { ApiPropertiesFactory } from '@shared/factories/api-properties/api-properties.factory';

@Injectable({
  providedIn: 'root'
})

export class SharepointLogoutService {
 constructor(private apiProperties: ApiPropertiesFactory) {}

  async logout(): Promise<void> {
    return new Promise((resolve, reject) => {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = this.apiProperties.sharepointLogoutUri;

      const timeout = setTimeout(() => {
        console.warn('SharePoint logout timed out');
        iframe.remove();
        reject('timeout');
      }, 30000);

      iframe.onload = () => {
        console.log('SharePoint logout finished');
        clearTimeout(timeout);
        setTimeout(() => iframe.remove(), 3000);
        resolve();
      };

      document.body.appendChild(iframe);
    });
  }
}
